import { styled } from 'styled-components';

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TextLinkStyle = styled.p`
  text-decoration: underline;
  color: ${({ theme }) => theme.primary_300};
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
